export const QUERY_KEY = 'query';
export const OPERATOR_EQUAL_KEY = '=';
export const OPERATOR_IN_KEY = 'in';
export const OPERATOR_AND_KEY = 'and';
export const OPERATOR_SPACE_KEY = ' ';
